// extracted by mini-css-extract-plugin
export default {"root":"XkosCQ","tr":"ndcIKv","br":"JexOJK","bl":"veMIsd","tl":"Lk4rr6"};